import { concatClasses } from "../../../helpers/concatClasses/index.js";
const backgroundColorMap = {
  attention: "bg-warning-100",
  disabled: "bg-neutral-50",
  info: "bg-secondary-100",
  default: "bg-neutral-100",
  success: "bg-success-100",
  critical: "bg-error-100",
  warning: "bg-primary-100",
  neutral: "bg-neutral-50"
};
const textColorMap = {
  attention: "text-warning-600",
  disabled: "text-neutral-400",
  info: "text-secondary-600",
  default: "text-neutral-700",
  success: "text-success-600",
  critical: "text-error-600",
  warning: "text-primary-600",
  neutral: "text-neutral-400"
};
const dotColorMap = {
  attention: "bg-warning-500",
  disabled: "bg-neutral-300",
  info: "bg-secondary-500",
  default: "bg-neutral-400",
  success: "bg-success-400",
  critical: "bg-error-400",
  warning: "bg-primary-500",
  neutral: "bg-neutral-400"
};
const getClasses = ({ dsf_square, dsf_level, dsf_size, isOnlyIconElement }) => {
  const classes = [
    "flex",
    "flex-auto",
    "gap-4",
    "items-center",
    "justify-center",
    backgroundColorMap[dsf_level],
    "dsf-text-xxs",
    "font-sans",
    textColorMap[dsf_level],
    "overflow-hidden"
  ];
  if (dsf_level === "disabled") {
    classes.push("select-none");
  }
  if (isOnlyIconElement) {
    if (dsf_size === "small") {
      classes.push("h-16", "w-16");
    } else {
      classes.push("h-24", "w-24");
    }
  } else {
    if (dsf_size === "small") {
      classes.push("h-16");
    } else {
      classes.push("h-24");
    }
  }
  if (dsf_square) {
    classes.push("rounded-sm");
  } else {
    classes.push("rounded-full");
  }
  if (isOnlyIconElement) {
    classes.push("p-4");
  } else if (dsf_square) {
    classes.push("px-4", "py-2");
  } else if (dsf_size === "small") {
    classes.push("px-4");
  } else {
    classes.push("px-8", "py-4");
  }
  return concatClasses(classes);
};
function getDotClasses({ dsf_level }) {
  const classes = ["rounded-full", "h-6", "w-6", dotColorMap[dsf_level]];
  return concatClasses(classes);
}
export {
  getClasses,
  getDotClasses
};
